var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinesSupportDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 898,
    height: 142,
    viewBox: "0 0 898 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H891C893.761 0 896 2.23858 896 5V142H0V5Z",
    fill: "#1E1E1E",
    fillOpacity: 0.45
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 894,
    height: 141
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 894,
    height: 141,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M-16.0225 156.916C35.375 100.872 150.585 31.5923 184.988 96.6305C320.035 351.956 554.982 62.5435 762.73 -144.385",
    stroke: "#4E55A2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-16.0225 286.265C3.90486 216.068 68.9431 -0.229655 169.64 -16.2091C295.513 -36.1891 208.141 126.245 304.95 163.588C399.842 200.186 826.239 38.5544 1082.74 -144.432",
    stroke: "#4E55A2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M-19.1731 45.3788C34.3223 -9.27467 145.088 -102.617 160.195 -38.6919C179.077 41.2204 193.237 278.446 339.564 272.618C456.624 267.956 623.092 138.873 829.035 -142.832",
    stroke: "#FF542E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesSupportDark);
export default __webpack_public_path__ + "static/media/lines_support_dark.3d9321fbbe99ba4142ec2399da391b4f.svg";
export { ForwardRef as ReactComponent };